import React, { useEffect, useState } from 'react';
import type { InvoiceLineItem } from '../../types';

const DECIMAL_RE = /^\d*\.?\d*$/;

interface InvoiceLineNumericFieldsProps {
  line: InvoiceLineItem;
  onUpdate: (patch: Partial<InvoiceLineItem>) => void;
}

const InvoiceLineNumericFields: React.FC<InvoiceLineNumericFieldsProps> = ({ line, onUpdate }) => {
  const [qtyStr, setQtyStr] = useState(line.quantity === 0 ? '' : String(line.quantity));
  const [priceStr, setPriceStr] = useState(line.unitPrice === 0 ? '' : String(line.unitPrice));

  useEffect(() => {
    setQtyStr(line.quantity === 0 ? '' : String(line.quantity));
    setPriceStr(line.unitPrice === 0 ? '' : String(line.unitPrice));
  }, [line.lineId, line.quantity, line.unitPrice]);

  return (
    <>
      <td className="px-2 py-1">
        <input
          type="text"
          inputMode="decimal"
          value={qtyStr}
          data-soft-keyboard-handled
          onChange={(e) => {
            const next = e.target.value;
            if (next !== '' && !DECIMAL_RE.test(next)) return;
            setQtyStr(next);
            if (next === '' || next === '.') {
              onUpdate({ quantity: 0 });
              return;
            }
            const parsed = parseFloat(next);
            onUpdate({ quantity: Number.isFinite(parsed) ? parsed : 0 });
          }}
          onBlur={() => {
            const parsed = parseFloat(qtyStr);
            if (!qtyStr || !Number.isFinite(parsed) || parsed <= 0) {
              setQtyStr('1');
              onUpdate({ quantity: 1 });
            }
          }}
          className="w-16 rounded border px-2 py-1 text-right"
        />
      </td>
      <td className="px-2 py-1">
        <input
          type="text"
          inputMode="decimal"
          value={priceStr}
          data-soft-keyboard-handled
          onChange={(e) => {
            const next = e.target.value;
            if (next !== '' && !DECIMAL_RE.test(next)) return;
            setPriceStr(next);
            if (next === '' || next === '.') {
              onUpdate({ unitPrice: 0 });
              return;
            }
            const parsed = parseFloat(next);
            onUpdate({ unitPrice: Number.isFinite(parsed) && parsed >= 0 ? parsed : 0 });
          }}
          className="w-24 rounded border px-2 py-1 text-right"
        />
      </td>
    </>
  );
};

export default InvoiceLineNumericFields;
